<label>
  <span class="add-file-wrapper"
    [class.required]="required"
    [class.loaded]="loaded">
    <app-custom-icons [type]="iconTypes.ATTACH"></app-custom-icons>
    @if (fileName) {
      <span class="add-file-name" [class.no-valid]="!valid">
        {{ fileName }}
      </span>
    } @else {
      <span class="label-content" [class.mandatory]="required">
        @if (label) {
          {{ label }}
        } @else {
          {{ 'file.addFile' | cxTranslate }}
        }
      </span>
    }
    @if (maxFileSize) {
      <span class="info-text">
        {{ 'maxFileSize' | cxTranslate: { fileSize: (maxFileSize / 1024 | number: '1.0-0') } }}
      </span>
    }
  </span>

  <input
    id="files"
    type="file"
    #fileUploadInput
    style="display: none"
    [attr.formControlName]="!!formGroup ? formControlName : null"
    (input)="onFileChange($event.target.files)">
  @if (!!formGroup) {
    <cx-form-errors [control]="formGroup.get(formControlName)"></cx-form-errors>
  }
</label>


@if (fileName) {
  <div class="reset-icon">
    <app-custom-icons (click)="removeImage()" [type]="iconTypes.CLOSE">
    </app-custom-icons>
  </div>
}

